import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { useRouter as useRouterContext } from 'next/router';
import { ParsedUrlQuery } from 'node:querystring';

import Anchor, { AnchorProperties } from '@fuww/components/src/Anchor';
import Routes, { Link, LinkProperties } from '../routes';

const getHref = (
  route: string, query?: ParsedUrlQuery | null,
) => Routes.findAndGetUrls(
  route,
  query,
).urls.as;

const linkAndAnchorPropertyTypes = {
  route: PropTypes.string,
  children: PropTypes.node,
  params: PropTypes.shape({}),
  href: PropTypes.string,
  useRouter: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  target: PropTypes.string,
  rel: PropTypes.string,
  scroll: PropTypes.bool,
};

type LinkAndAnchorProperties = AnchorProperties
& InferProps<typeof linkAndAnchorPropertyTypes> & LinkProperties;

const LinkAndAnchor = ({
  route,
  params: parameters = {},
  children,
  href,
  useRouter = true,
  className,
  title,
  onClick,
  target,
  rel,
  scroll = true,
  ...anchorProperties
}: LinkAndAnchorProperties) => {
  const { query: { prefix } = {} } = useRouterContext();

  return (
    useRouter
      ? (
        <Link
          route={route}
          params={parameters}
          href={href}
          scroll={scroll}
          passHref
        >
          <Anchor
            className={className}
            title={title}
            onClick={onClick}
            target={target}
            rel={rel}
            styled
            {...anchorProperties}
          >
            {children}
          </Anchor>
        </Link>
      )
      : (
        <Anchor
          href={href ?? getHref(route, prefix ? {
            ...parameters, prefix,
          } : parameters)}
          className={className}
          onClick={onClick}
          title={title}
          target={target}
          rel={rel}
          styled
          {...anchorProperties}
        >
          {children}
        </Anchor>
      )
  );
};

LinkAndAnchor.propTypes = linkAndAnchorPropertyTypes;

export default LinkAndAnchor;
